import React, { createContext, useContext, useState, useCallback } from 'react';
import { getCartCounter } from '../API/ProductAPI';
import Config from '../API/Config';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const refreshCartCount = useCallback(async () => {
    const IsLogin = Config.getUserIsLogin();
    const StateId = Config.getStateId();
    const CountryId = Config.getCountryId();

    if (IsLogin && StateId && CountryId) {
      try {
        const res = await getCartCounter(CountryId, StateId);
        if (res?.status && res?.responseData) {
          setCartCount(res.responseData.CartCount || 0);
        }
      } catch (error) {
        console.error('Error fetching cart count:', error);
      }
    } else {
      setCartCount(0);
    }
  }, []);

  return (
    <CartContext.Provider value={{ cartCount, refreshCartCount }}>
      {children}
    </CartContext.Provider>
  );
};